import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Table } from "../../components";
import utils from "../../components/toastify/toastify";
import { fish_image } from "../../constant/urls";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall

const PaymentDetails = (props) => {
  const [
    verify_payment_support_fish_error,
    verify_payment_support_fish_loading,
    verify_payment_support_fish_data,
    verify_payment_support_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_payment_support_fish",
    isFunction: true,
  });

  const [
    verify_payment_term_fish_error,
    verify_payment_term_fish_loading,
    verify_payment_term_fish_data,
    verify_payment_term_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_payment_term_fish",
    isFunction: true,
  });

  const [
    verify_cart_fish_error,
    verify_cart_fish_loading,
    verify_cart_fish_data,
    verify_cart_fish_function,
  ] = useRequest({
    method: "post",
    url: "/verify_cart_fish",
    isFunction: true,
  });

  let history = useHistory();
  const [
    get_payment_details_error,
    get_payment_details_loading,
    get_payment_details_data,
    get_payment_details_function,
  ] = useRequest({
    method: "post",
    url: "/get_payment_details",
    body: {
      payment_id: props.match.params.id,
    },
  });

  const data = get_payment_details_data?.data;

  return !data ? null : (
    <>
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  {/* <li class="breadcrumb-item active">افزودن محصول جدید</li> */}
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <section className="card card-body">
          <div class="row" style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "10px" }}></div>
            <div style={{ marginBottom: "10px" }}>
              کد رهگیری : {data._ref_id}
            </div>
            <div style={{ marginBottom: "10px" }}>
              توضیحات پرداخت :{" "}
              {data._des === "initial_payment" ? "پرداخت اولیه" : null}
              {data._des === "term_support_payment"
                ? "پرداخت پشتیبانی ترم"
                : null}
              {data._des === "term_payment" ? "پرداخت ترم" : null}
            </div>

            <div style={{ marginBottom: "10px" }}>تصویر فیش واریزی :</div>
            {data.fish_img ? (
              <>
                {" "}
                <img
                  src={fish_image + data.fish_img.name}
                  alt="fish"
                  style={{
                    width: "100%",
                    maxWidth: "30rem",
                    objectFit: "cover",
                    marginBottom: "10px",
                  }}
                />
                <div style={{ marginBottom: "10px" }}>
                  وضعیت تراکنش :
                  {data._status === "paid"
                    ? "پرداخت شده"
                    : data._status === "unpaid"
                    ? "پرداخت نشده"
                    : data._status === "waiting"
                    ? "در انتظار تایید"
                    : null}
                  {data._status === "paid" ? (
                    <button
                      type="button"
                      class="btn btn-warning round mr-1 mb-1 btn-sm"
                      style={{ width: "fit-content" }}
                      onClick={() => {
                        {
                          data._des === "initial_payment"
                            ? verify_cart_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_support_payment"
                            ? verify_payment_support_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_payment"
                            ? verify_payment_term_fish_function({
                                payment_id: props.match.params.id,
                                _status: false,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت رد شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                      }}
                    >
                      رد فیش
                    </button>
                  ) : null}
                  {data._status === "unpaid" ? (
                    <button
                      type="button"
                      class="btn btn-success round mr-1 mb-1 btn-sm"
                      style={{ width: "fit-content" }}
                      onClick={() => {
                        {
                          data._des === "initial_payment"
                            ? verify_cart_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_support_payment"
                            ? verify_payment_support_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                        {
                          data._des === "term_payment"
                            ? verify_payment_term_fish_function({
                                payment_id: props.match.params.id,
                                _status: true,
                              })
                                .then(() => {
                                  utils.showAlert(
                                    "فیش با موفقیت تایید شد",
                                    "success"
                                  );
                                  history.goBack();
                                })
                                .catch(() =>
                                  utils.showAlert(
                                    "مشکلی در انجام عملیات به وجود آمد",
                                    "error"
                                  )
                                )
                            : null;
                        }
                      }}
                    >
                      تایید فیش
                    </button>
                  ) : null}
                  {data._status === "waiting" ? (
                    <>
                      <button
                        type="button"
                        class="btn btn-success round mr-1 mb-1 btn-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => {
                          {
                            data._des === "initial_payment"
                              ? verify_cart_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_support_payment"
                              ? verify_payment_support_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_payment"
                              ? verify_payment_term_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: true,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت تایید شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                        }}
                      >
                        تایید فیش
                      </button>
                      <button
                        type="button"
                        class="btn btn-warning round mr-1 mb-1 btn-sm"
                        style={{ width: "fit-content" }}
                        onClick={() => {
                          {
                            data._des === "initial_payment"
                              ? verify_cart_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_support_payment"
                              ? verify_payment_support_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                          {
                            data._des === "term_payment"
                              ? verify_payment_term_fish_function({
                                  payment_id: props.match.params.id,
                                  _status: false,
                                })
                                  .then(() => {
                                    utils.showAlert(
                                      "فیش با موفقیت رد شد",
                                      "success"
                                    );
                                    history.goBack();
                                  })
                                  .catch(() =>
                                    utils.showAlert(
                                      "مشکلی در انجام عملیات به وجود آمد",
                                      "error"
                                    )
                                  )
                              : null;
                          }
                        }}
                      >
                        رد فیش
                      </button>
                    </>
                  ) : null}
                </div>
              </>
            ) : null}
          </div>
        </section>
      </div>
      {/* <!-- BEGIN: Content--> */}
    </>
  );
};

export { PaymentDetails };
